define('modules/campaigns/modal/pause_ad_modal',[
  'backbone',
  'jquery',
  '_',
  'moment',
  'pikaday',
  'text!./pause_ad_modal_template.html',
  'session'
], function (Backbone, $, _,
  moment,
  Pikaday,
  modal_template,
  session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
    },

    hasSidebar: false,
    pickers: [],
    subViews: [],
    tagName: 'div',
    className: 'play-ad-modal',
    template: _.template(modal_template),

    events: {
      'click .js-cancel': 'closeModal',
      'click .js-pause-ad': 'pauseAd'
    },

    render: function () {
      this.$el.html(this.template({ bookingIds: this.bookingIds }));
      this.addDatePickers();
      return this;
		},

    getCurrentDate: function () {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth();
      var day = today.getDate();
      return new Date(year, month, day);
    },

    addDatePickers: function () {
      var view = this;
      this.$('#input_id-end_date').each(function () {
        var field = this,
          picker = new Pikaday({
            field: field,
            firstDay: 1,
            showWeekNumber: true,
            format: _.t('date_format'),
            setDefaultDate: true,
            i18n: session.get('lang').phrases.pikaday,
            onSelect: function (date) {
              if (date < view.getCurrentDate()) {
                $('.js-pause-ad')
                  .prop('disabled', true)
                  .addClass('button-disabled');
                $('.error-text')
                  .text(_.t('campaigns.central_campaign.pause_ad_modal.error-text'));
              }
              else {
                $('.js-pause-ad')
                  .prop('disabled', false)
                  .removeClass('button-disabled');
                $('.error-text')
                  .text('');
              }
            },
          });
        view.pickers.push(picker);
      }, this);
    },

    pauseAd: function (e) {
      e.preventDefault();

      var selectedEndDate = $('.js-pause-ad-date-picker').val();

      if (selectedEndDate) {
        Backbone.trigger('campaigns:pauseads', {
          'bookingIds': this.bookingIds,
          'locationCode': this.locationCode,
          'endDate': selectedEndDate
        });
        this.trigger('close');
      }
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.pickers, function (picker) {
          picker.destroy();
      }, this);
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

